module.exports = __webpack_public_path__ + "img/logo-hematology.695e7ead.png";